;(function () {
  function bindLivePreviewForForm($form) {
    const previewUrl =
      $form.attr("data-preview-url") ||
      $form.data("preview-url") ||
      $form.data("previewUrl") ||
      ""

    const targetSelector =
      $form.attr("data-preview-target") ||
      $form.data("preview-target") ||
      $form.data("previewTarget") ||
      ""

    const $target = $(targetSelector)
    if (!previewUrl || !$target.length) return

    const method = (
      $form.attr("data-preview-method") ||
      $form.data("preview-method") ||
      "GET"
    ).toUpperCase()

    const debounceMs =
      parseInt(
        $form.attr("data-preview-debounce") ||
          $form.data("preview-debounce") ||
          "150",
        10
      ) || 0

    let timer = null

    function triggerPreviewRequest() {
      if (timer) clearTimeout(timer)

      const runRequest = function () {
        $.ajax({
          url: previewUrl,
          type: method,
          data: $form.serialize(),
          dataType: "html",
          headers:
            method === "POST"
              ? { "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content") }
              : undefined,
          success: function (html) {
            $target.html(html)
          },
          error: function (xhr) {
            console.error("Preview error", xhr)
          },
        })
      }

      if (debounceMs > 0) {
        timer = setTimeout(runRequest, debounceMs)
      } else {
        runRequest()
      }
    }

    $form.off(".livePreview")
    $form.on(
      "input.livePreview change.livePreview keyup.livePreview paste.livePreview",
      "input, textarea, select",
      triggerPreviewRequest
    )
    $form.on(
      "select2:select.livePreview select2:clear.livePreview",
      "select",
      triggerPreviewRequest
    )
    $form.on(
      "summernote.change.livePreview",
      ".js-textEditor-basic",
      triggerPreviewRequest
    )

    triggerPreviewRequest()
  }

  function bindAllLivePreviews() {
    $('[data-live-preview="true"]').each(function () {
      bindLivePreviewForForm($(this))
    })
  }

  $(document).on("turbolinks:load turbo:load", bindAllLivePreviews)
})()
